import { Outlet, createRootRoute, createRoute, Router, Navigate } from '@tanstack/react-router'

import Home from '../pages/Home'
import KitchenSink from '../pages/KitchenSink'
import Dashboard from '../pages/Dashboard'
import MainLayout from '../layouts/MainLayout'
import CreatePlan from '../pages/CreatePlan'
import { useAuth } from '@/api/hooks/useAuth'
import Plan from '@/pages/Plan'
import ImportCsv from '@/pages/ImportCsv'
import Staff from '@/pages/Staff'
import DetailedPlan from '@/pages/DetailedPlan'

// ルートレイアウト
function RootLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}

type ProtectedRouteProps = {
  children: React.ReactNode
}

function ProtectedRoute() {
  const { isAuthenticated } = useAuth()
  console.log("protected route", isAuthenticated)
  if (!isAuthenticated) return <Navigate to="/" />
  return <Outlet />
}

// ルートの定義
const rootRoute = createRootRoute({
  component: RootLayout
})

// 認証必須ルート用のラッパー（layout）
const authProtectedRoute = createRoute({
  id: 'protected',
  getParentRoute: () => rootRoute,
  component: ProtectedRoute,
})


// ホーム
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Home
})

// キッチンシンク
const kitchenSinkRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/kitchen-sink',
  component: KitchenSink
})

/** 以下は認証が必要なルート */

// ダッシュボード（認証必須）
const dashboardRoute = createRoute({
  getParentRoute: () => authProtectedRoute,
  path: '/dashboard',
  component: Dashboard
})

const createPlanRoute = createRoute({
  getParentRoute: () => authProtectedRoute,
  path: '/create-plan',
  component: CreatePlan
});

const importCsvRoute = createRoute({
  getParentRoute: () => authProtectedRoute,
  path: '/import-csv',
  component: ImportCsv
});

const planRoute = createRoute({
  getParentRoute: () => authProtectedRoute,
  path: '/plan',
  component: Plan
});

const staffRoute = createRoute({
  getParentRoute: () => authProtectedRoute,
  path: '/staff',
  component: Staff
});

const detailedPlanRoute = createRoute({
  getParentRoute: () => authProtectedRoute,
  path: '/detailed-plan',
  component: DetailedPlan
});

const protectedRoutes = authProtectedRoute.addChildren([
  dashboardRoute,
  createPlanRoute,
  importCsvRoute,
  planRoute,
  staffRoute,
  detailedPlanRoute
]);

// ルートツリーを定義
const routeTree = rootRoute.addChildren([
  indexRoute,
  kitchenSinkRoute,
  protectedRoutes,
])

// ルーターを作成
export const router = new Router({ routeTree })
